import { useState } from 'react';

import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { AppDownloadModal } from '../../AppDownloadModal/AppDownloadModal';

import { Button, IButtonProps } from './Button';

interface IProps {
  id: string;
  source: string;
  isFollowed?: boolean;
  buttonProps?: IButtonProps;
  customAppDownloadHeader?: string;
}

export const FollowButton = ({
  isFollowed,
  id,
  source,
  buttonProps = {},
  customAppDownloadHeader,
}: IProps) => {
  const { currentPage } = useAnalytics();

  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);

  const onClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source,
        source_id: id,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  return (
    <>
      <Button
        variant={isFollowed ? 'buttonSecondary' : 'buttonPrimary'}
        onClick={onClick}
        size="sm"
        data-testid="FollowButton"
        {...buttonProps}
      >
        {isFollowed ? 'Following' : 'Follow'}
      </Button>
      <AppDownloadModal
        appDownloadSource={source}
        appDownloadSourceId={id}
        modalHeader={customAppDownloadHeader ?? 'Sign up to follow'}
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </>
  );
};
